import script from "./SceneThumbnail.vue?vue&type=script&lang=ts&setup=true"
export * from "./SceneThumbnail.vue?vue&type=script&lang=ts&setup=true"

import "./SceneThumbnail.vue?vue&type=style&index=0&id=22f7248e&lang=scss&scoped=true"

import exportComponent from "/opt/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22f7248e"]])

export default __exports__